import style from "./RecommendTab.module.css";
import icon1 from "../../assets/images/ricon/1.png";
import icon2 from "../../assets/images/ricon/2.png";
import icon3 from "../../assets/images/ricon/3.png";
import icon4 from "../../assets/images/ricon/4.png";
import icon5 from "../../assets/images/ricon/5.png";
import icon6 from "../../assets/images/ricon/6.png";
import icon1a from "../../assets/images/ricon/a1.png";
import icon2a from "../../assets/images/ricon/a2.png";
import icon3a from "../../assets/images/ricon/a3.png";
import icon4a from "../../assets/images/ricon/a4.png";
import icon5a from "../../assets/images/ricon/a5.png";
import icon6a from "../../assets/images/ricon/a6.png";
import san from "../../assets/images/ricon/san.png";
import { useState, useEffect } from "react";
import request from "../../common/request";
import { Link, useSearchParams } from "react-router-dom";
export default function Main() {
  const [currentActive, setCurrentActive] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();
  var id = searchParams.get("id");

  const [list, setList] = useState([]);
  useEffect(() => {
    console.log("eff");
    request.getColumnList("推荐服务").then((result) => {
      console.log(result.data);
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        data.forEach((element) => {
          element.isActive = false;
        });
        for (var i = 0; i < data.length; i++) {
          if (id && data[i].id == id) {
            setCurrentActive(i);
          }
        }

        setList(data);
      }
      console.log("list", data);
    });
  }, []);

  return (
    <>
      <div className={style.tabbox}>
        <div className={style.tabheader}>
          <div className={style.tabheaderc}>
            {list.map((item, index) => {
              return (
                <div
                  className={currentActive == index ? style.active : ""}
                  onClick={() => {
                    setCurrentActive(index);
                  }}
                  key={index}
                >
                  <img
                    src={
                      require("../../assets/images/ricon/" +
                        (index + 1) +
                        ".png").default
                    }
                    className={style.icon}
                  />
                  <img
                    src={
                      require("../../assets/images/ricon/a" +
                        (index + 1) +
                        ".png").default
                    }
                    className={style.aicon}
                  />
                  <h2>{item.title}</h2>
                  {currentActive == index && (
                    <img src={san} className={style.san} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className={style.tabbody}>
          {list.map((item, index) => {
            return (
              <div
                className={
                  style.r999 +
                  " " +
                  (index == currentActive ? style.active : style.inactive)
                }
                key={index}
              >
                {item.sub_column.map((item2, index2) => {
                  return (
                    <a href="https://www.zgjmdbw.com" target="_blank">
                      <div className={style.li} key={index2}>
                        <div className={style.header}>
                          <div>
                            <span>0{index2 + 1}</span>
                            <span className={style.bar}></span>
                          </div>
                          <h3>{item2.title}</h3>
                          <p>{item2.desc}</p>
                        </div>
                        <p>{item2.content}</p>
                      </div>
                    </a>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div className={"clear div100"}></div>
      </div>
    </>
  );
}
